<template>
  <div>
    <div class="form-section">
      <h3>Quà tặng hàng ngày <br> TQC Tần Tử Anh</h3>
      <div class="login-inner-form">
        <div class="form-group mb-0" style="text-align: left; color: violet;">
          - Quà tặng được gửi qua NPC Đại Hồng Lư <br/>
          - Mỗi ngày nhận 1 lần <br/>
          - Cần phải làm trống NPC Đại Hồng Lư trước khi nhận thêm <br/>
        </div>
        <br/>
        <div class="form-group mb-0" v-if="!received">
          <button type="button" @click="dailyGift" class="btn-md btn-theme btn-block">Nhận quà tặng</button>
        </div>
        <div v-else>
          Hôm nay bạn đã nhận quà rồi!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'DailyGift',
    components: {
    },
    props: {
      tqc_api: '',
      token: '',
      user: {}
    },
    mounted() {
      this.$emit('get-info')
      if (localStorage.daily != null) {
        this.received = localStorage.daily
      }
    },
    methods: {
      dailyGift() {
        if (this.clicked) {
          return false
        }

        this.clicked = true

        axios.post(`${this.tqc_api}daily-gift`, {
          token: this.token
        }).then(({
          data
        }) => {
          this.clicked = false
          if (data.error) {
            alert(data.error)
          } else {
            this.received = true
            localStorage.daily = true
            alert(data.data)
          }
        }).catch((error) => {
          this.clicked = false
          this.received = true
          localStorage.daily = true
          alert(`Hôm nay bạn đã nhận quà rồi, mai quay lại nhóe !`)
        })
      }
    },
    data() {
      return {
        email: '',
        password: '',
        clicked: false,
        received: false
      }
    }
  }
</script>
